import React from "react";
import { ReactComponent as HomeIcon } from "assets/icons/hoem.svg";
import { ReactComponent as RiskReportIcon } from "assets/icons/riskReport.svg";
import { ReactComponent as UserIcon } from "assets/icons/userGroup.svg";
import { ReactComponent as PointIcon } from "assets/icons/pointManagement.svg";
import { ReactComponent as SystemIcon } from "assets/icons/systemOptions.svg";
import { ReactComponent as CertificateIcon } from "assets/icons/certificate.svg";
import { ReactComponent as ProfileIcon } from "assets/icons/profile.svg";
import { ReactComponent as ReportIcon } from "assets/icons/export.svg";
import { ReactComponent as PointMartIcon } from "assets/icons/pointMart.svg";
import { ReactComponent as BreachRecordIcon } from "assets/icons/breachRecord.svg";

import { LEVELS, RESOURCES } from "constants/permissions";
import {
  ADMINS,
  CERTIFICATE,
  COURSES,
  HOME,
  MY_ACCOUNT,
  RISK_REPORT,
  USERS,
  SAFETY_REASON,
  SITE_AND_ZONE,
  SUB_CONTRACTOR,
  REPORT,
  TRAINING_REPORT,
  STORE_MANAGEMENT,
  ORDER_MANAGEMENT,
  PRODUCT_CATEGORY,
  SAFETY_POINT_MANAGEMENT,
  REWARD_POINT_MANAGEMENT,
  USER_GROUP,
  BREACH_RECORD,
  COMPANY,
  ADVERTISEMENT,
  CONFIGURATION,
} from "./paths";

const MENU_ITEMS = [
  {
    name: "Home",
    path: HOME,
    icon: <HomeIcon />,
    resources: ["*"],
  },
  {
    name: "Company",
    path: COMPANY,
    icon: <HomeIcon />,
    level: LEVELS.ORGANIZATION,
    resources: [RESOURCES.COMPANY],
  },
  {
    name: "Certificate",
    path: CERTIFICATE,
    icon: <CertificateIcon />,
    resources: [RESOURCES.CERTIFICATE],
    nestedPath: true,
  },
  {
    name: "RiskManagement",
    path: RISK_REPORT,
    icon: <RiskReportIcon />,
    resources: [RESOURCES.RISK_REPORT],
    nestedPath: true,
  },
  {
    name: "PointManagement",
    icon: <PointIcon />,
    children: [
      {
        name: "SafetyPointManagement",
        path: SAFETY_POINT_MANAGEMENT,
        resources: [RESOURCES.SAFETY_POINT],
        nestedPath: true,
      },
      {
        name: "RewardPointManagement",
        path: REWARD_POINT_MANAGEMENT,
        resources: [RESOURCES.REWARD_POINT],
        nestedPath: true,
      },
    ],
  },
  {
    name: "BreachRecord",
    path: BREACH_RECORD,
    icon: <BreachRecordIcon />,
    resources: [RESOURCES.BREACH_RECORD],
    nestedPath: true,
  },
  {
    name: "Report",
    path: REPORT,
    icon: <ReportIcon />,
    resources: [RESOURCES.REPORT],
    nestedPath: true,
  },
  {
    name: "Users",
    path: USERS,
    icon: <UserIcon />,
    resources: [RESOURCES.APP_USER],
    nestedPath: true,
  },
  {
    name: "PointMart",
    icon: <PointMartIcon />,
    children: [
      {
        name: "StoreManagement",
        path: STORE_MANAGEMENT,
        resources: [RESOURCES.PRODUCT],
        nestedPath: true,
      },
      {
        name: "ProductCategory",
        path: PRODUCT_CATEGORY,
        resources: [RESOURCES.PRODUCT_CATEGORY],
      },
      {
        name: "OrderManagement",
        path: ORDER_MANAGEMENT,
        resources: [RESOURCES.ORDER_MANAGEMENT],
        nestedPath: true,
      },
    ],
  },
  {
    name: "SystemOptions",
    icon: <SystemIcon />,
    children: [
      {
        name: "Admins",
        path: ADMINS,
        resources: [RESOURCES.ADMIN_USER],
      },
      {
        name: "SiteAndZone",
        path: SITE_AND_ZONE,
        resources: [RESOURCES.CONSTRUCTION_SITE],
        nestedPath: true,
      },
      {
        name: "SafetyReason",
        path: SAFETY_REASON,
        resources: [RESOURCES.POINT_ITEM],
      },
      {
        name: "Courses",
        path: COURSES,
        resources: [RESOURCES.COURSE_CATEGORY],
      },
      {
        name: "TrainingReport",
        path: TRAINING_REPORT,
        resources: [RESOURCES.TRAINING_CATEGORY],
      },
      {
        name: "Configuration",
        path: CONFIGURATION,
        level: LEVELS.ORGANIZATION,
        resources: [RESOURCES.CONFIGURATION],
      },
      {
        name: "SubContractor",
        path: SUB_CONTRACTOR,
        resources: [RESOURCES.SUB_CONTRACTOR],
      },
      {
        name: "UserGroup",
        path: USER_GROUP,
        level: LEVELS.ORGANIZATION,
        resources: [RESOURCES.ADMIN_USER_GROUP],
      },
      {
        name: "Advertisement",
        path: ADVERTISEMENT,
        level: LEVELS.ORGANIZATION,
        resources: [RESOURCES.ADVERTISEMENT],
      },
    ],
  },
  {
    name: "MyAccount",
    path: MY_ACCOUNT,
    icon: <ProfileIcon />,
    resources: ["*"],
  },
];

export default MENU_ITEMS;
